import axios from "axios";
import { API_BASE_URL } from "../config";

const CLIENT_TIMEOUT_MS = 12000;

/**
 * Ask the backend to confirm a monitoring URL responds.
 * The backend allows only public http(s) destinations.
 * @param {string} url
 */
export async function pingMonitoringUrl(url) {
  const res = await axios.post(
    `${API_BASE_URL}/gate3/monitoring-reachability`,
    { url },
    { timeout: CLIENT_TIMEOUT_MS }
  );
  return res.data;
}
